"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const MapSideBarNavigation_vue_1 = __importDefault(require("@becrop/components/Tracking/Proposals/Playground/Components/MapSideBarNavigation.vue"));
const MapSideBarPanelSamplingPoints_vue_1 = __importDefault(require("@becrop/components/Tracking/Proposals/Playground/Components/MapSideBarPanelSamplingPoints.vue"));
const MapSideBarPanelExport_vue_1 = __importDefault(require("@becrop/components/Tracking/Proposals/Playground/Components/MapSideBarPanelExport.vue"));
let MapSideBar = class MapSideBar extends vue_property_decorator_1.Vue {
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    showModalSampleAssociation() {
        this.$emit('showModalSampleAssociation');
    }
    setActivePanel(value) {
        this.$emit('activePanel', value);
    }
    downloadReport() {
        this.$emit('downloadReport', true);
    }
    changePanel(panel) {
        this.$emit('changePanel', panel);
    }
    onMapExport(format) {
        this.$emit('onMapExport', format);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'single' })
], MapSideBar.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MapSideBar.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapSideBar.prototype, "isBMK", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapSideBar.prototype, "activePanel", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], MapSideBar.prototype, "areas", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], MapSideBar.prototype, "samplingPoints", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: null })
], MapSideBar.prototype, "tabActive", void 0);
MapSideBar = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            MapSideBarPanelSamplingPoints: MapSideBarPanelSamplingPoints_vue_1.default,
            MapSideBarNavigation: MapSideBarNavigation_vue_1.default,
            MapSideBarPanelExport: MapSideBarPanelExport_vue_1.default,
        },
    })
], MapSideBar);
exports.default = MapSideBar;
